import { Box, Container, Tab } from "@mui/material";
import React, { useState } from "react";

//page imports
import Payout from "./Payout";
import PayoutHistory from "./PayoutHistory";

//dialog imports
import CreatePayoutDialog from "./Dialogs/CreatePayoutDialog";
import HeaderHelpPage from "../HeaderHelpPage";
import TabsMenu from "../TabsMenu";
import { TabPanel } from "@mui/lab";

function PayoutSwitchView({ userRole }) {
  const [selectedView, setSelectedView] = useState("All");

  const handleChange = (event, newValue) => {
    setSelectedView(newValue);
  };
  return (
    <Container>
      <HeaderHelpPage title="Merchant Payout Info" description="Review merchant payout info" />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="History" value="History" />
        {selectedView === "All" && <Box><CreatePayoutDialog /></Box>}
        
        <TabPanel value="All">
          <Payout userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <PayoutHistory />
        </TabPanel>
      </TabsMenu>
    </Container>
  );
}

export default PayoutSwitchView;
